/** SDS-flavoured class map for the Lexical letter editor. */
export var EDITOR_THEME = {
  paragraph: "mb-2",
  heading: {
    h1: "text-style-heading-main mb-2",
    h2: "text-style-subheading mb-2",
    h3: "text-style-body-strong mb-2"
  },
  list: {
    ul: "list-disc pl-6 mb-2",
    ol: "list-decimal pl-6 mb-2",
    listitem: "mb-1"
  },
  quote: "border-l-2 border-sds-base-default pl-3 text-sds-base-secondary",
  link: "text-sds-brand-default underline",
  text: {
    bold: "font-bold",
    italic: "italic",
    underline: "underline"
  }
};